import { Switch, SwitchProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import BoltIcon from 'assets/icons-gray/bolt.svg'
import NoIcon from 'assets/icons-gray/no.svg'

const CoreSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme, checked, defaultChecked }) => ({
  width: 48,
  height: 24,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(24px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: theme.palette.primary,
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.1,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 20,
    height: 20,
  },
  '& .MuiSwitch-track': {
    borderRadius: 20,
    backgroundColor: theme.palette.mode === 'light' ? '#666666' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 18,
      height: 16,
    },
    '&:before': {
      display: checked || defaultChecked ? 'block' : 'none',
      backgroundImage: `url(${BoltIcon})`,
      left: 5,
    },
    '&:after': {
      display: checked || defaultChecked ? 'none' : 'block',
      backgroundImage: `url(${NoIcon})`,
      backgroundRepeat: 'no-repeat',
      right: 4,
      top: 15,
    },
  },
}))

export default CoreSwitch
